import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { AuthProvider } from './AuthContext';
// Imported for its side effect: it registers the `beforeinstallprompt`
// listener at module scope. Chrome fires that event once, early, and if it is
// not captured before React mounts the one-tap install prompt is lost.
import './lib/install';
import './styles/app.css';

/**
 * Register the service worker.
 *
 * Done here rather than via the plugin's auto-inject so the timing is
 * explicit: the worker must be registered and active before any push
 * subscription attempt, and on iOS a subscription made against a
 * not-yet-controlling worker fails in a way that is hard to diagnose later.
 */
if ('serviceWorker' in navigator) {
  // Start registration immediately so authenticated photo requests can be
  // scoped before the feed begins painting. Registration is non-blocking.
  navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch((error) => {
    console.error('[family] Service worker registration failed', error);
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider><App /></AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
